/* ==========================================================================
   PanelAccommodation > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'PANEL_ACCOMMODATION::DESTROY';

const SET_DATA = 'PANEL_ACCOMMODATION::SET_DATA';
const ADD_ROOM = 'PANEL_ACCOMMODATION::ADD_ROOM';
const REMOVE_ROOM = 'PANEL_ACCOMMODATION::REMOVE_ROOM';
const UPDATE_ROOMS = 'PANEL_ACCOMMODATION::UPDATE_ROOMS';
const SET_ERROR = 'PANEL_ACCOMMODATION::SET_ERROR';
const SET_VALID = 'PANEL_ACCOMMODATION::SET_VALID';
const SET_INFO = 'PANEL_ACCOMMODATION::SET_INFO';
const REMOVE_INFO = 'PANEL_ACCOMMODATION::REMOVE_INFO';
const ENABLE_INCREMENT = 'PANEL_ACCOMMODATION::ENABLE_INCREMENT';
const DISABLE_INCREMENT = 'PANEL_ACCOMMODATION::DISABLE_INCREMENT';

/* Actions */
const destroy = () => ({ type: DESTROY });
const setData = payload => ({ type: SET_DATA, payload });
const addRoom = payload => ({ type: ADD_ROOM, payload });
const removeRoom = payload => ({ type: REMOVE_ROOM, payload });
const updateRooms = payload => ({ type: UPDATE_ROOMS, payload });
const setError = payload => ({ type: SET_ERROR, payload });
const setValid = () => ({ type: SET_VALID });
const setInfo = payload => ({ type: SET_INFO, payload });
const removeInfo = payload => ({ type: REMOVE_INFO, payload });
const enableIncrement = () => ({ type: ENABLE_INCREMENT });
const disableIncrement = () => ({ type: DISABLE_INCREMENT });

/* Exports */
module.exports = {
    types: {
        SET_DATA,
        ADD_ROOM,
        REMOVE_ROOM,
        UPDATE_ROOMS,
        SET_ERROR,
        SET_VALID,
        SET_INFO,
        REMOVE_INFO,
        ENABLE_INCREMENT,
        DISABLE_INCREMENT,
        DESTROY
    },
    actions: {
        setData,
        addRoom,
        removeRoom,
        updateRooms,
        setError,
        setValid,
        setInfo,
        removeInfo,
        enableIncrement,
        disableIncrement,
        destroy
    }
};
